/*
  Einstiegspunkt für /shiftplan_v2.
  Importiert die Styles und exportiert die Seitenkomponente.
*/

import "../../design-system/styles/tokens.css";
import "../../design-system/styles/components.css";
import "./styles/base.css";
import "./styles/toolbar.css";
import "./styles/month-grid.css";
import "./styles/panels.css";
import "./styles/dialog.css";
import "./styles/shift-editor.css";
import "./styles/export.css";
import "./styles/solver.css";
import ShiftplanV2Page from "./app/ShiftplanV2Page";

export default ShiftplanV2Page;
